The name of the party that owns the position opening.
